import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { CircularProgress, Typography, Container, Box } from "@mui/material";
import CommentSection from "../Components/CommentSection.js";

const VerifyEmailPage = () => {
  const [message, setMessage] = useState("Verifying...");
  const [isLoading, setIsLoading] = useState(true);  // Track loading state to prevent multiple calls
  const navigate = useNavigate();

  useEffect(() => {
    const verifyEmail = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const urlToken = searchParams.get("token");
      console.log("Token from URL:", urlToken);
      const token = urlToken || localStorage.getItem("token");  // Use token from URL or localStorage
      if (!token) {
        setMessage("Invalid verification link.");
        setIsLoading(false);  // Stop loading when token is invalid
        return;
      }

      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/welcome/verify-email`, { params: { token } });

        if (res.data.token) {
          localStorage.setItem("token", res.data.token);  // Update the token if returned
        }

        setMessage(res.data.message);

        const preAuthState = JSON.parse(localStorage.getItem("preAuthState"));
        setTimeout(() => {
          if (preAuthState && preAuthState.path &&  preAuthState.path.startsWith("/")) {
            navigate(`${preAuthState.path}${preAuthState.search || ""}`);
            window.scrollTo(0, 0);
            localStorage.removeItem("preAuthState");
          } else {
            navigate("/");  // Redirect to homepage if no specific path
          }
        }, 1500);
      } catch (error) {
        console.error("Verification error:", error);
        setMessage(error.response?.data?.message || "Verification failed or already verified. Please check by logging out and logging in.");
      } finally {
        setIsLoading(false);  // Stop loading once the API call is finished
      }
    };

    // Only trigger verifyEmail on component mount
    if (isLoading) {
      verifyEmail();
    }
  }, [navigate, isLoading]);  // Dependency array ensures that useEffect only runs once

  return (
    <Box sx={{ minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Container maxWidth="sm" sx={{ textAlign: "center" }}>
        <Typography variant="h6" sx={{ mb: 2 }}>{message}</Typography>
        {isLoading && <CircularProgress sx={{ mt: 2 }} />}  {/* Show loading spinner only while isLoading is true */}
      </Container>
    </Box>
  );
};

export default VerifyEmailPage;
